import React from "react";
import { Route, Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/account.service";
import Loader from "../common/loader";
import NotFoundPage from "../components/errors/404";
import { ROLES } from "../constants/general.constant";
import CustomerDashboard from "../components/customers/dashboards";
import CustomerProfile from "../components/customers/profile/customerProfile";
import ProspectKYCForm from "../components/customers/prospect-kyc/prospectKYCForm";
import MainLayout from "../layout/mainLayout";
import {useAuth} from "../hook/userRoleHook";
import Notifications from "../components/customers/notifications";
import MyBusinesses from "../components/customers/my-businesses";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { role, loading, redirectionUrl, isLoginPage } = useAuth();

  if (!isAuthenticated() && !isLoginPage) {
    return <Navigate to={redirectionUrl} replace />;
  }

  if (loading) return <Loader />;

  if (role !== ROLES.CUSTOMER) return <NotFoundPage />;

  return <>{children}</>;
};

const WithLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const WithoutLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const customerRoutesConfig = [
  { key: "customer-dashboard", path: "/customer/dashboard", element: <CustomerDashboard />, layout: "with" },
  { key: "customer-profile", path: "/customer/profile", element: <CustomerProfile />, layout: "with" },
  { key: "prospect-profile", path: "/customer/prospect-profile", element: <ProspectKYCForm />, layout: "with" },
  { key: "customer-notifications", path: "/customer/notifications", element: <Notifications />, layout: "with" },
  { key: "my-businesses", path: "/customer/my-businesses", element: <MyBusinesses />, layout: "with" },
];

const CustomerRoutes = customerRoutesConfig.map(({ key, path, element, layout }) => (
  <Route
    key={key}
    path={path}
    element={layout === "with" ? <WithLayout>{element}</WithLayout> : <WithoutLayout>{element}</WithoutLayout>}
  />
));

export default CustomerRoutes;
